import { useTranslation } from '@spcc/core'
import { FileText, Plus, TableEmptyState } from '@spcc/uikit'

interface SalesOrdersEmptyStateProps {
  onCreateNew: () => void
  createDisabled?: boolean
  createDisabledReason?: string
}

export function SalesOrdersEmptyState({
  onCreateNew,
  createDisabled = false,
  createDisabledReason,
}: SalesOrdersEmptyStateProps) {
  const { t } = useTranslation()

  return (
    <div className="glass-card rounded-2xl overflow-hidden border border-border/50 flex items-center justify-center">
      <div className="w-full">
        <TableEmptyState
          icon={FileText}
          title={t('salesOrders.noSalesOrders')}
          description={t('salesOrders.noOrdersDescription')}
          actionLabel={createDisabled ? undefined : t('salesOrders.createFirst')}
          actionIcon={createDisabled ? undefined : Plus}
          onAction={createDisabled ? undefined : onCreateNew}
        />
        {createDisabled && createDisabledReason ? (
          <p className="pb-6 text-center text-sm text-muted-foreground">
            {createDisabledReason}
          </p>
        ) : null}
      </div>
    </div>
  )
}
